import { ArticleTypes } from '../actions/articleAction';

const defaultState = {
  isLoadingAnnouncement: true,
  isLoadingFeature: true,
  isLoadingTopNews: true,
  isLoadingMajorOutage: true,
  announcementList: [],
  featureList: [],
  topNewsList: [],
  majorOutageList: []
};

const articleReducer = (state = defaultState, action: any) => {
  const { announcementList, featureList, topNewsList, majorOutageList } = action;

  switch (action.type) {
    case ArticleTypes.GET_LIST_ANNOUNCEMENT_SUCCESS:
      return {
        ...state,
        announcementList,
        isLoadingAnnouncement: false,
      }
    case ArticleTypes.GET_LIST_FEATURE_SUCCESS:
      return {
        ...state,
        isLoadingFeature: false,
        featureList
      }

    case ArticleTypes.GET_TOP_NEWS_SUCCESS:
      return {
        ...state,
        topNewsList,
        isLoadingTopNews: false,
      }
    case ArticleTypes.GET_LIST_MAJOR_OUTAGE_SUCCESS:
      return {
        ...state,
        majorOutageList,
        isLoadingMajorOutage: false,
      }
  }
  return state;
};

export default articleReducer;
